import { Component, Input, OnInit } from '@angular/core';
import { EnrollmentDetail } from '../../models/enrollment-detail';

@Component({
    selector: 'app-enrollment-detail',
    templateUrl: './enrollment-detail.component.html',
    styleUrls: ['./enrollment-detail.component.scss']
})
export class EnrollmentDetailComponent implements OnInit {

    @Input() enrollment: EnrollmentDetail;

    public approbationTypes: string[];

    constructor() { }

    ngOnInit() {

        this.getApprobationTypes();

    }

    private getApprobationTypes() {

        this.approbationTypes = [... new Set(this.enrollment.approbations.map(a => a.approbation.approbationType.type))];

    }

    public getApprobationsByType(approbationType: string) {

        return this.enrollment.approbations.filter(item => item.approbation.approbationType.type === approbationType);

    }

}
